import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCkcwOWsYS5SF9S4e8xVfRMdFSj_KGdRm4",
  authDomain: "todolist-30ecc.firebaseapp.com",
  databaseURL: "https://todolist-30ecc-default-rtdb.firebaseio.com",
  projectId: "todolist-30ecc",
  storageBucket: "todolist-30ecc.appspot.com",
  messagingSenderId: "845975035839",
  appId: "1:845975035839:web:40fdb5ce5448f09b9bcb0a",
  measurementId: "G-PJFQQV5KVN",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getDatabase(app);
export const auth = getAuth();
